import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import ServiceDetail from './pages/ServiceDetail';
import Gallery from './pages/Gallery';
import TestimonialsPage from './pages/TestimonialsPage';
import SponsorshipsPage from './pages/SponsorshipsPage';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';
import Forbidden from './pages/Forbidden';

function App() {
  return (
    <HelmetProvider>
      <div className="flex flex-col min-h-screen bg-brand-cream text-brand-charcoal antialiased">
        {/* Scroll restoration */}
        <ScrollToTop />

        {/* Header / Navigation */}
        <Header />

        {/* Main Content */}
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/om-os" element={<About />} />
            <Route path="/ydelser/:slug" element={<ServiceDetail />} />
            <Route path="/galleri" element={<Gallery />} />
            <Route path="/anbefalinger" element={<TestimonialsPage />} />
            <Route path="/vi-stoetter" element={<SponsorshipsPage />} />
            <Route path="/kontakt" element={<Contact />} />
            <Route path="/403" element={<Forbidden />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>

        {/* Footer */}
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
